import { AllCamerasIdGroup } from '@/globals/constants';
import { put, get, post, del } from './api/http.service';

// Get directory camera group
export const getDirectoryGroup = (params) => {
  return get('/ccs/v1/camera/directory/role/cameraGroup', params);
};

// update directory camera group
export const updateDirectoryGroup = (payload) => {
  return put('/ccs/v1/camera/directory/role/cameraGroup', payload);
};

// Get camera group list  -  カメラグループリスト取得
export const getCameraGroupList = (params) => {
  return get('/ccs/v1/camera/setting/group', params).then((groups) => {
    if (groups.tags && groups.tags.length > 0) {
      // find the index of the group with the id of `AllCamerasIdGroup`
      const allCamGroupIndex = groups.tags.findIndex(
        (group) => group.id === AllCamerasIdGroup
      );

      // if the group with the id of `AllCamerasIdGroup` is found, set its name to "すべてのカメラ"
      if (allCamGroupIndex > -1) {
        groups.tags[allCamGroupIndex].name = 'すべてのカメラ';
      }
    }
    return groups;
  });
};

// Get camera group roles
export const getCameraRoles = (params) => {
  params.avatarIds = params.avatarIds.join(',');
  return get('/ccs/v1/user/avatar/role/cameraGroup', params);
};

// Update camera group roles
export const updateCameraRoles = (payload) => {
  return put('/ccs/v1/user/avatar/role/cameraGroup', payload);
};

// Create camera group  -  カメラグループ作成
export const createCameraGroup = (payload) => {
  return post(
    '/ccs/v1/camera/setting/group',
    payload,
    (error) => !(error.status === 400 && error.errorCode === 14)
  );
};

// Update camera group  -  カメラグループ変更
export const updateCameraGroup = (payload) => {
  return put('/ccs/v1/camera/group', payload);
};

// Update camera group setting  -  カメラグループ変更
export const updateCameraGroupSetting = (payload) => {
  return put(
    '/ccs/v1/camera/setting/group',
    payload,
    (error) => !(error.status === 400 && error.errorCode === 14)
  );
};

// Delete camera group  -  カメラグループ削除
export const deleteCameraGroup = (payload) => {
  return del('/ccs/v1/camera/setting/group', payload);
};

// Update camera group order
export const updateCameraGroupOrder = (payload) => {
  return put('/ccs/v1/camera/setting/group/order', payload);
};
